export type VenueProfile = {
  id: string;
  // ListingCard fields
  name: string;
  location: string;
  thumb: string;
  details: string;
  rating?: number;
  reviewCount?: number;
  // Profile-only fields
  images: string[];
  description: string;
  facilities: string[];
  hours: string;
  pricing: string;
  contact: { phone?: string; email?: string; address?: string };
  mapUrl?: string;
  qrCode?: string;
  bookingLink?: string;
};

export const servicesData: Record<string, Record<string, VenueProfile[]>> = {
  'sports-venues': {
    'cricket-pitch': [
      {
        id: 'cp-1',
        name: 'Tiento Sports',
        location: 'Mission Road · 1.1 km',
        thumb: '/tiento.png',
        details: 'Bookable',
        rating: 4.5,
        reviewCount: 120,
        images: ['/images/tiento.png'],
        description: 'Multi-sport venue with bookable slots.',
        facilities: ['Floodlights', 'Locker Rooms'],
        hours: '6 AM – 10 PM',
        pricing: '₹700 per hour',
        contact: { phone: '+91 8619439126', address: 'Mission Road · 1.1 km' },
        qrCode: '/images/fitness.png',
        bookingLink: 'https://api.whatsapp.com/send/?phone=919351504729&text=Book++Gym&type=phone_number&app_absent=0',
      },
      {
        id: 'cp-2',
        name: 'Fusion – The Turf',
        location: 'Next to KSH · 1.1 km',
        thumb: '/c2.png',
        details: 'Bookable',
        rating: 4.3,
        reviewCount: 85,
        images: ['/images/c2.png'],
        description: 'Synthetic turf venue for games and practice.',
        facilities: ['Floodlights'],
        hours: '7 AM – 9 PM',
        pricing: '₹600 per hour',
        contact: { phone: '+91 8619439126', address: 'Next to KSH · 1.1 km' },
        qrCode: '/images/fitness.png',
        bookingLink: 'https://api.whatsapp.com/send/?phone=919351504729&text=Book++Gym&type=phone_number&app_absent=0',
      },
    ],

    'football-turf': [
      {
        id: 'ft-1',
        name: 'Bangalore Football Turf',
        location: 'Hennur Ring · Royal Towers',
        thumb: '/f1.png',
        details: 'Soccer field',
        rating: 4.5,
        reviewCount: 230,
        images: ['/images/f1.png'],
        description: 'Soccer field with bookable slots.',
        facilities: ['Night Lighting'],
        hours: '7 AM – 11 PM',
        pricing: '₹1200 per hour',
        contact: { phone: '+91 8619439126', address: 'Royal Towers, Hennur Ring' },
        qrCode: '/images/fitness.png',
        bookingLink: 'https://api.whatsapp.com/send/?phone=919351504729&text=Book++Gym&type=phone_number&app_absent=0',
      },
    ],

    'pickleball': [
      {
        id: 'pb-1',
        name: 'PicknPadel Arena – Padel & Pickleball',
        location: 'Begur',
        thumb: '/p1.png',
        details: 'Sports complex',
        rating: 4.8,
        reviewCount: 45,
        images: ['/images/p1.png'],
        description: 'Padel & Pickleball sports complex.',
        facilities: ['Coaching', 'Pro Shop'],
        hours: '8 AM – 10 PM',
        pricing: '₹800 per hour',
        contact: { phone: '+91 8619439126', address: 'Begur' },
        qrCode: '/images/fitness.png',
        bookingLink: 'https://api.whatsapp.com/send/?phone=919351504729&text=Book++Gym&type=phone_number&app_absent=0',
      },
    ],
  },

'fitness-venues': {
  'zumba': [
    {
      id: 'zumba-1',
      name: 'Amit Fitness studio',
      location: 'Malaviya nagar',
      thumb: '/images/amit-dance.mov',
      details: 'Zumba sessions',
      rating: 4.6,
      reviewCount: 60,
      images: ['/images/amit-dance.png'],
      description: 'Energetic Zumba sessions for cardio & fun.',
      facilities: ['Dance Floor', 'Instructor', 'Music'],
      hours: '7 AM – 9 AM',
      pricing: '₹99 per session',
      contact: { phone: '+91 8619439126', address: 'Malaviya nagar' },
      qrCode: '/images/fitness.png',
      bookingLink: 'https://api.whatsapp.com/send/?phone=919351504729&text=Book++Gym&type=phone_number&app_absent=0',
    },
    {
      id: 'zumba-2',
      name: 'Fit and Gold Gym',
      location: 'Raja Park',
      thumb: '/images/fng.png',
      details: 'Zumba sessions',
      rating: 4.6,
      reviewCount: 60,
      images: ['/images/fng.png'],
      description: 'Energetic Zumba sessions for cardio & fun.',
      facilities: ['Dance Floor', 'Instructor', 'Music'],
      hours: '7 AM – 9 AM',
      pricing: '₹99 per session',
      contact: { phone: '+91 8619439126', address: 'Raja Park' },
      qrCode: '/images/fitness.png',
      bookingLink: 'https://api.whatsapp.com/send/?phone=919351504729&text=Book++Gym&type=phone_number&app_absent=0',
    },
        {
      id: 'zumba-3',
      name: 'CrossFit Gym',
      location: 'Bapu Nagar Park',
      thumb: '/images/CrossFit Gym.png',
      details: 'Fully equipped gym',
      rating: 4.2,
      reviewCount: 180,
      images: ['/images/CrossFit Gym.png'],
      description: 'Fully equipped gym for strength & endurance training.',
      facilities: ['Weights', 'Machines', 'Personal Training'],
      hours: '6 AM – 11 PM',
      pricing: '₹99 per session',
      contact: { phone: '+91 8619439126', address: 'Raja Park' },
      qrCode: '/images/fitness.png',
      bookingLink: 'https://api.whatsapp.com/send/?phone=919351504729&text=Book++Gym&type=phone_number&app_absent=0',
    },
    {
      id: 'zumba-4',
      name: 'Sweatbox Gym',
      location: 'Raja Park',
      thumb: 'https://lh3.googleusercontent.com/gps-cs-s/AHVAwerxUpxAs0A45nGGxyf4gra143UMT3pBLXfEONIhWlxMP4YBEJwECFnv4oygJ02ZZEHrJYJJBixf1IuS9MCKCIUQ2EV3tYuE3M9hwKF_Yt555FGF4X7HO_ovKyhKGilzqdq8fZK4=s1360-w1360-h1020-rw',
      details: 'Functional training gym',
      rating: 4.3,
      reviewCount: 95,
      images: ['https://lh3.googleusercontent.com/p/AF1QipN4ORSvcvxZBpkSg9dTOlbslHFrhRgmKH1CVwgl=s1360-w1360-h1020-rw'],
      description: 'Functional training & modern workout machines.',
      facilities: ['Weights', 'Cross-training', 'Trainer'],
      hours: '6 AM – 10 PM',
      pricing: '₹99 per session',
      contact: { phone: '+91 8619439126', address: 'Raja Park' },
      qrCode: '/images/fitness.png',
      bookingLink: 'https://api.whatsapp.com/send/?phone=919351504729&text=Book++Gym&type=phone_number&app_absent=0',
    },
  ],

 "gym": [
  {
      "id": "gym-1",
      "name": "MUSCLE MONSTERZ GYM",
      "location": "Mahadevapura, Bengaluru",
      "thumb": "/images/musle-monsterz.png",
      "details": "Bodybuilding and transformation",
      "rating": 4.6,
      "reviewCount": 196,
      "images": ["/images/musle-monsterz.png"],
      "description": "Become the best version of yourself with our specialized transformation programs and bodybuilding focus.",
      "facilities": ["Weights", "Cardio", "Trainer"],
      "hours": "5:30 am–10 pm, 7–11 am",
      "pricing": "₹99 per session",
      "contact": {
        "phone": "+91 8619439126",
        "address": "Mahadevapura"
      },
      "qrCode": "/images/fitness.png",
      "bookingLink": "https://api.whatsapp.com/send/?phone=919351504729&text=Book++Gym&type=phone_number&app_absent=0"
    },
    {
      "id": "gym-2",
      "name": "Answer is Fitness",
      "location": "Marathahalli, Bengaluru",
      "thumb": "/images/Answer is Fitness.png",
      "details": "Complete fitness solutions",
      "rating": 4.4,
      "reviewCount": 351,
      "images": ["/images/Answer is Fitness.png"],
      "description": "Finding the right workout is easy here; we provide the ultimate answer to all your fitness goals.",
      "facilities": ["Weights", "Cardio", "Trainer"],
      "hours": "6 AM – 10 PM",
      "pricing": "₹99 per session",
      "contact": {
        "phone": "+91 8619439126",
        "address": "Marathahalli"
      },
      "qrCode": "/images/fitness.png",
      "bookingLink": "https://api.whatsapp.com/send/?phone=919351504729&text=Book++Gym&type=phone_number&app_absent=0"
    },
    {
      "id": "gym-3",
      "name": "Force Fitness Gym",
      "location": "Mahadevapura, Bengaluru",
      "thumb": "/images/force-f.png",
      "details": "Hardcore strength training",
      "rating": 4.2,
      "reviewCount": 215,
      "images": ["/images/force-f.png"],
      "description": "Ignite your strength at Force Fitness, featuring a wide array of heavy weights and expert guidance.",
      "facilities": ["Weights", "Cardio", "Trainer"],
      "hours": "6 AM – 10 PM",
      "pricing": "₹99 per session",
      "contact": {
        "phone": "+91 8619439126",
        "address": "Mahadevapura"
      },
      "qrCode": "/images/fitness.png",
      "bookingLink": "https://api.whatsapp.com/send/?phone=919351504729&text=Book++Gym&type=phone_number&app_absent=0"
    },
    {
      "id": "gym-4",
      "name": "PR fitness gym",
      "location": "Garudachar Palya, Bengaluru",
      "thumb": "/images/pr.png",
      "details": "Community focused fitness",
      "rating": 4.7,
      "reviewCount": 482,
      "images": ["/images/pr.png"],
      "description": "A welcoming gym environment in Garudachar Palya offering personalized training and top-tier equipment.",
      "facilities": ["Weights", "Cardio", "Trainer"],
      "hours": "6 AM – 10 PM",
      "pricing": "₹99 per session",
      "contact": {
        "phone": "+91 8619439126",
        "address": "Garudachar Palya"
      },
      "qrCode": "/images/fitness.png",
      "bookingLink": "https://api.whatsapp.com/send/?phone=919351504729&text=Book++Gym&type=phone_number&app_absent=0"
    },
    {
      "id": "gym-5",
      "name": "Pulse Fitness Center",
      "location": "Indiranagar, Bengaluru",
      "thumb": "/images/pulse.png",
      "details": "Premium fitness center",
      "rating": 4.8,
      "reviewCount": 342,
      "images": ["/images/pulse.png"],
      "description": "A high-end fitness facility located within the Bagmane Constellation Business Park, perfect for corporate professionals.",
      "facilities": ["Weights", "Cardio", "Trainer"],
      "hours": "6 AM – 10 PM",
      "pricing": "₹99 per session",
      "contact": {
        "phone": "+91 8619439126",
        "address": "Indiranagar"
      },
      "qrCode": "/images/fitness.png",
      "bookingLink": "https://api.whatsapp.com/send/?phone=919351504729&text=Book++Gym&type=phone_number&app_absent=0"
    },
    {
      "id": "gym-6",
      "name": "Wisdom martial arts and fitness centre",
      "location": "Mahadevapura, Bengaluru",
      "thumb": "/images/karate.png",
      "details": "Martial arts and strength training",
      "rating": 4.5,
      "reviewCount": 128,
      "images": ["/images/karate.png"],
      "description": "Expert martial arts coaching combined with modern fitness equipment for a holistic workout.",
      "facilities": ["Weights", "Cardio", "Trainer"],
      "hours": "6 AM – 10 PM",
      "pricing": "₹99 per session",
      "contact": {
        "phone": "+91 8619439126",
        "address": "Mahadevapura"
      },
      "qrCode": "/images/fitness.png",
      "bookingLink": "https://api.whatsapp.com/send/?phone=919351504729&text=Book++Gym&type=phone_number&app_absent=0"
    },
    {
      "id": "gym-7",
      "name": "Euro Fitness Center",
      "location": "Kaggadasapura, Bengaluru",
      "thumb": "/images/Euro Fitness Center.jpg",
      "details": "Gym & Fitness",
      "rating": 4.4,
      "reviewCount": 351,
      "images": ["/images/Euro Fitness Center.jpg"],
      "description": "A well-equipped fitness center offering a variety of memberships and workout sessions.",
      "facilities": ["Weights", "Cardio", "Personal Training"],
      "hours": "Mon-Sat: Morning & Evening Slots",
      "pricing": "Starting at ₹99 per session",
      "contact": {
        "address": "2nd Floor, G.K.Plaza, next to SCT College, Kondappa Layout, Vignan Nagar, Doddanekundi, Kaggadasapura, Bengaluru, Karnataka 560075"
      },
      "qrCode": "/images/euro fitness.png",
      "bookingLink": "https://api.whatsapp.com/send/?phone=919351504729&text=Book+Euro+Fitness+Center&type=phone_number&app_absent=0"
    },
    {
      "id": "gym-8",
      "name": "Fit and Gold Gym",
      "location": "Raja Park",
      "thumb": "/images/fng.png",
      "details": "Modern gym",
      "rating": 4.4,
      "reviewCount": 210,
      "images": ["/images/fng.png"],
      "description": "Modern gym with strength and cardio equipment.",
      "facilities": ["Weights", "Cardio", "Trainer"],
      "hours": "6 AM – 10 PM",
      "pricing": "₹99 per session",
      "contact": {
        "phone": "+91 8619439126",
        "address": "Raja Park"
      },
      "qrCode": "/images/fitness.png",
      "bookingLink": "https://api.whatsapp.com/send/?phone=919351504729&text=Book++Gym&type=phone_number&app_absent=0"
    },
    {
      "id": "gym-8",
      "name": "CrossFit Gym",
      "location": "Bapu Nagar Park",
      "thumb": "/images/CrossFit Gym.png",
      "details": "Fully equipped gym",
      "rating": 4.2,
      "reviewCount": 180,
      "images": ["/images/CrossFit Gym.png"],
      "description": "Fully equipped gym for strength & endurance training.",
      "facilities": ["Weights", "Machines", "Personal Training"],
      "hours": "6 AM – 11 PM",
      "pricing": "₹99 per session",
      "contact": {
        "phone": "+91 8619439126",
        "address": "Raja Park"
      },
      "qrCode": "/images/fitness.png",
      "bookingLink": "https://api.whatsapp.com/send/?phone=919351504729&text=Book++Gym&type=phone_number&app_absent=0"
    },
    {
      "id": "gym-9",
      "name": "Sweatbox Gym",
      "location": "Raja Park",
      "thumb": "https://lh3.googleusercontent.com/p/AF1QipN4ORSvcvxZBpkSg9dTOlbslHFrhRgmKH1CVwgl=s1360-w1360-h1020-rw",
      "details": "Functional training gym",
      "rating": 4.3,
      "reviewCount": 95,
      "images": ["https://lh3.googleusercontent.com/p/AF1QipN4ORSvcvxZBpkSg9dTOlbslHFrhRgmKH1CVwgl=s1360-w1360-h1020-rw"],
      "description": "Functional training & modern workout machines.",
      "facilities": ["Weights", "Cross-training", "Trainer"],
      "hours": "6 AM – 10 PM",
      "pricing": "₹99 per session",
      "contact": {
        "phone": "+91 8619439126",
        "address": "Raja Park"
      },
      "qrCode": "/images/fitness.png",
      "bookingLink": "https://api.whatsapp.com/send/?phone=919351504729&text=Book++Gym&type=phone_number&app_absent=0"
    },
    {
      "id": "gym-10",
      "name": "Fitness Connection",
      "location": "Rajapark",
      "thumb": "https://lh3.googleusercontent.com/p/AF1QipMCJ78ZGMoyZ-1lCdTqN3Hij82Y0vPL-j0NtlfR=s1360-w1360-h1020-rw",
      "details": "Spacious modern gym",
      "rating": 4.1,
      "reviewCount": 145,
      "images": ["https://lh3.googleusercontent.com/p/AF1QipMCJ78ZGMoyZ-1lCdTqN3Hij82Y0vPL-j0NtlfR=s1360-w1360-h1020-rw"],
      "description": "Spacious gym with modern equipment.",
      "facilities": ["Weights", "Cardio", "Lockers"],
      "hours": "6 AM – 10 PM",
      "pricing": "₹99 per session",
      "contact": {
        "phone": "+91 8619439126",
        "address": "Vidyadhar Nagar"
      },
      "qrCode": "/images/fitness.png",
      "bookingLink": "https://api.whatsapp.com/send/?phone=919351504729&text=Book++Gym&type=phone_number&app_absent=0"
    },
    {
      "id": "gym-11",
      "name": "Fitness Zone",
      "location": "Jawahar nagar, Jaipur",
      "thumb": "https://lh3.googleusercontent.com/gps-cs-s/AHVAwerPvA1r5rITmoBeH8d3OXBhSbwRBm-QhUQEdkAYhotuNEwSVnbVZ6gI94HXceovJyFSs6VSi3HKPMCkixKdBinCziCc0tuEikzGnD3lkD40bQ3nhGv25okjbRsFST53VKTALww=s1360-w1360-h1020-rw",
      "details": "Spacious modern gym",
      "rating": 4.1,
      "reviewCount": 145,
      "images": ["https://lh3.googleusercontent.com/gps-cs-s/AHVAwerPvA1r5rITmoBeH8d3OXBhSbwRBm-QhUQEdkAYhotuNEwSVnbVZ6gI94HXceovJyFSs6VSi3HKPMCkixKdBinCziCc0tuEikzGnD3lkD40bQ3nhGv25okjbRsFST53VKTALww=s1360-w1360-h1020-rw"],
      "description": "Spacious gym with modern equipment.",
      "facilities": ["Weights", "Cardio", "Lockers"],
      "hours": "6 AM – 10 PM",
      "pricing": "₹99 per session",
      "contact": {
        "phone": "+91 8619439126",
        "address": "Jawahar Nagar"
      },
      "qrCode": "/images/fitness.png",
      "bookingLink": "https://api.whatsapp.com/send/?phone=919351504729&text=Book++Gym&type=phone_number&app_absent=0"
    },
    {
      "id": "gym-12",
      "name": "One Rule Gym",
      "location": "Raja Park",
      "thumb": "https://lh3.googleusercontent.com/gps-cs-s/AG0ilSwhMp7yBIEdzNXrD6TIROue5d4wwUJS57bAtLj1KEdo3jwi_T1A3C2Sgsd3cCktzEm_BYVmq1-iyINNyIghEY8x3NQmyRfIcP2tGeFi88yztsgeJpWsGSEX-SJw1OSS6mPQtTMnvpK-90r8=s1360-w1360-h1020-rw",
      "details": "Strength training gym",
      "rating": 4.5,
      "reviewCount": 120,
      "images": ["https://lh3.googleusercontent.com/gps-cs-s/AG0ilSwhMp7yBIEdzNXrD6TIROue5d4wwUJS57bAtLj1KEdo3jwi_T1A3C2Sgsd3cCktzEm_BYVmq1-iyINNyIghEY8x3NQmyRfIcP2tGeFi88yztsgeJpWsGSEX-SJw1OSS6mPQtTMnvpK-90r8=s1360-w1360-h1020-rw"],
      "description": "High-energy gym focused on strength training.",
      "facilities": ["Weights", "Cardio", "Trainer"],
      "hours": "6 AM – 10 PM",
      "pricing": "₹99 per session",
      "contact": {
        "phone": "+91 8619439126",
        "address": "Raja Park"
      },
      "qrCode": "/images/fitness.png",
      "bookingLink": "https://api.whatsapp.com/send/?phone=919351504729&text=Book++Gym&type=phone_number&app_absent=0"
    },
    {
      "id": "gym-13",
      "name": "The Core Fitness Gym",
      "location": "Raja Park",
      "thumb": "https://lh3.googleusercontent.com/p/AF1QipNe3Fmd3Tlg5IJ55xHCdVjRCFlSh9lJT6A3gd92=s1360-w1360-h1020-rw",
      "details": "Strength training gym",
      "rating": 4.5,
      "reviewCount": 120,
      "images": ["https://lh3.googleusercontent.com/p/AF1QipNe3Fmd3Tlg5IJ55xHCdVjRCFlSh9lJT6A3gd92=s1360-w1360-h1020-rw"],
      "description": "High-energy gym focused on strength training.",
      "facilities": ["Weights", "Cardio", "Trainer"],
      "hours": "6 AM – 10 PM",
      "pricing": "₹99 per session",
      "contact": {
        "phone": "+91 8619439126",
        "address": "Raja Park"
      },
      "qrCode": "/images/fitness.png",
      "bookingLink": "https://api.whatsapp.com/send/?phone=919351504729&text=Book++Gym&type=phone_number&app_absent=0"
    }
  ],

  'yoga': [
    {
      id: 'yoga-1',
      name: 'Group workout & MUSICAL YOGA',
      location: 'Central Park',
      thumb: '/images/parkyoga.png',
      details: 'Yoga session',
      rating: 4.8,
      reviewCount: 35,
      images: ['/images/parkyoga.png'],
      description: 'Refreshing yoga with music in a group setting.',
      facilities: ['Yoga Mats', 'Music', 'Instructor'],
      hours: '6 AM – 9 PM',
      pricing: '₹50 per session',
      contact: { phone: '+91 8619439126', address: 'Central Park' },
      qrCode: '/images/fitness.png',
      bookingLink: 'https://api.whatsapp.com/send/?phone=919351504729&text=Book++Gym&type=phone_number&app_absent=0',
    },
    {
      id: 'yoga-2',
      name: 'Rebirth Yoga Studio',
      location: 'Ajmer Rd, Jaipur',
      thumb: 'https://lh3.googleusercontent.com/gps-cs-s/AHVAwep9vpkWubdRoTliYHu0egMCg_T1kTPNwbm0vB_JwH3lFPZLKGCG3utzuCuibWTRas0NYHQ-R5LaSwDP75xFMnaZClJB_ehfSMqnIuAAIC59yJr_vAAuIXu9EWqkqTS7KiHFVd72aCTPH4o9=s1360-w1360-h1020-rw',
      details: 'Yoga session',
      rating: 4.8,
      reviewCount: 35,
      images: ['https://lh3.googleusercontent.com/gps-cs-s/AHVAwep9vpkWubdRoTliYHu0egMCg_T1kTPNwbm0vB_JwH3lFPZLKGCG3utzuCuibWTRas0NYHQ-R5LaSwDP75xFMnaZClJB_ehfSMqnIuAAIC59yJr_vAAuIXu9EWqkqTS7KiHFVd72aCTPH4o9=s1360-w1360-h1020-rw'],
      description: 'Therapeutic Yoga',
      facilities: ['Yoga Mats', 'Music', 'Instructor'],
      hours: '6 AM – 9 PM',
      pricing: '₹70 per session',
      contact: { phone: '+91 8619439126', address: 'Central Park' },
      qrCode: '/images/fitness.png',
      bookingLink: 'https://api.whatsapp.com/send/?phone=919351504729&text=Book++Gym&type=phone_number&app_absent=0',
    },
     {
      id: 'yoga-3',
      name: 'Tattvaa Yoga & Therapeutic Centre',
      location: 'Raja Park, Jaipur',
      thumb: 'https://lh3.googleusercontent.com/gps-cs-s/AHVAweoa6LS_0awo3r49EonTyDDiFUNTILAC9Wg9v7SABnjOeUaGvVgeMKbv45WvOS5tkvuh0cG1yIfEzN-YIwXoBGbcZKNw2hsMUD0yAGb2qHmnZ9rMMU06hVr-1XNYTGg04WNXB5T-qQ=s1360-w1360-h1020-rw',
      details: 'Yoga session',
      rating: 4.8,
      reviewCount: 35,
      images: ['https://lh3.googleusercontent.com/gps-cs-s/AHVAweoa6LS_0awo3r49EonTyDDiFUNTILAC9Wg9v7SABnjOeUaGvVgeMKbv45WvOS5tkvuh0cG1yIfEzN-YIwXoBGbcZKNw2hsMUD0yAGb2qHmnZ9rMMU06hVr-1XNYTGg04WNXB5T-qQ=s1360-w1360-h1020-rw'],
      description: 'Therapeutic Yoga',
      facilities: ['Yoga Mats', 'Music', 'Instructor'],
      hours: '6 AM – 9 PM',
      pricing: '₹99 per session',
      contact: { phone: '+91 8619439126', address: 'Raja Park' },
      qrCode: '/images/fitness.png',
      bookingLink: 'https://api.whatsapp.com/send/?phone=919351504729&text=Book++Gym&type=phone_number&app_absent=0',
    },
     {
      id: 'yoga-4',
      name: 'Prakartik Yog Nilayam By Anshu',
      location: 'Jawahar nagar, Rajapark, Jaipur',
      thumb: '/images/anshu.jpg',
      details: 'Yoga session',
      rating: 5,
      reviewCount: 32,
      images: ['/images/anshu.jpg'],
      description: 'Therapeutic Yoga',
      facilities: ['Yoga Mats', 'Music', 'Instructor'],
      hours: '6 AM – 9 PM',
      pricing: ' per session',
      contact: { phone: '+91 8619439126', address: 'Jawahar nagar, Rajapark, Jaipur' },
      qrCode: '/images/fitness.png',
      bookingLink: 'https://api.whatsapp.com/send/?phone=919351504729&text=Book++Gym&type=phone_number&app_absent=0',
    },
     {
      id: 'yoga-5',
      name: 'Tapas Studio By Surya Yogini',
      location: 'Ajmer Rd, Jaipur',
      thumb: 'https://lh3.googleusercontent.com/gps-cs-s/AHVAweovxv-ZAdrAMO4YD724HS_pLyFKeGc87fKWRxSKkgjkwowZI8VFZlxcXUJwGPvW1D4POgVj0VHpsl4hFScRKcy4eSjYX0Btrdw2hmS96p32rI4s7C98NbgAGGwIcvkfcDGO7LEQ=s1360-w1360-h1020-rw',
      details: 'Yoga session',
      rating: 4.8,
      reviewCount: 35,
      images: ['https://lh3.googleusercontent.com/gps-cs-s/AHVAweovxv-ZAdrAMO4YD724HS_pLyFKeGc87fKWRxSKkgjkwowZI8VFZlxcXUJwGPvW1D4POgVj0VHpsl4hFScRKcy4eSjYX0Btrdw2hmS96p32rI4s7C98NbgAGGwIcvkfcDGO7LEQ=s1360-w1360-h1020-rw'],
      description: 'Therapeutic Yoga',
      facilities: ['Yoga Mats', 'Music', 'Instructor'],
      hours: '6 AM – 9 PM',
      pricing: '₹70 per session',
      contact: { phone: '+91 8619439126', address: 'Central Park' },
      qrCode: '/images/fitness.png',
      bookingLink: 'https://api.whatsapp.com/send/?phone=919351504729&text=Book++Gym&type=phone_number&app_absent=0',
    },
    {
      id: 'yoga-7',
      name: 'Musical yoga By Amit',
      location: 'Malaviya nagar, Jaipur',
      thumb: 'https://www.oceans7ashwem.com/images/amit-yoga.jpg',
      details: 'Yoga session',
      rating: 4.8,
      reviewCount: 35,
      images: ['https://www.oceans7ashwem.com/images/amit-yoga.jpg'],
      description: 'Therapeutic Yoga',
      facilities: ['Yoga Mats', 'Music', 'Instructor'],
      hours: '6 AM – 9 PM',
      pricing: '₹50 per session',
      contact: { phone: '+91 8619439126', address: 'Malaviya nagar, Jaipur'},
      qrCode: '/images/fitness.png',
      bookingLink: 'https://api.whatsapp.com/send/?phone=919351504729&text=Book++Gym&type=phone_number&app_absent=0',
    },
    {
      id: 'yoga-8',
      name: 'Musical yoga By Gauri Shankar',
      location: 'At your home, Jaipur',
      thumb: 'https://www.oceans7ashwem.com/images/yoga.jpg',
      details: 'Yoga session',
      rating: 4.8,
      reviewCount: 35,
      images: ['https://www.oceans7ashwem.com/images/yoga.jpg'],
      description: 'Therapeutic Yoga',
      facilities: ['Yoga Mats', 'Music', 'Instructor'],
      hours: '6 AM – 9 PM',
      pricing: '₹50 per session',
      contact: { phone: '+91 8619439126', address: 'At your home, Jaipur'},
      qrCode: '/images/fitness.png',
      bookingLink: 'https://api.whatsapp.com/send/?phone=919351504729&text=Book++Gym&type=phone_number&app_absent=0',
    },
  ],

  'nature_workout': [
    {
      id: 'nw-1',
      name: 'Group NATURE Fun workout',
      location: 'Bhagat Singh Park · Raja Park',
      thumb: '/images/nature workout.png',
      details: 'Outdoor workout',
      rating: 4.7,
      reviewCount: 48,
      images: ['/images/nature workout.png'],
      description: 'Outdoor group workout surrounded by nature.',
      facilities: ['Outdoor', 'Group', 'Bodyweight'],
      hours: '7 AM – 9 AM',
      pricing: '₹50 per session [2 hrs]',
      contact: { phone: '+91 8619439126', address: 'Bhagat Singh Park · Raja Park' },
      qrCode: '/images/fitness.png',
      bookingLink: 'https://api.whatsapp.com/send/?phone=919351504729&text=Book++Gym&type=phone_number&app_absent=0',
    },
    {
      id: 'nw-2',
      name: 'Group workout & MUSICAL YOGA',
      location: 'Central Park',
      thumb: '/images/parkyoga.png',
      details: 'Nature workout & yoga',
      rating: 4.6,
      reviewCount: 30,
      images: ['/images/parkyoga.png'],
      description: 'Combination of workout & yoga in nature.',
      facilities: ['Yoga Mats', 'Music', 'Instructor'],
      hours: '6 AM – 9 AM',
      pricing: '₹50 per session',
      contact: { phone: '+91 8619439126', address: 'Central Park' },
      qrCode: '/images/fitness.png',
      bookingLink: 'https://api.whatsapp.com/send/?phone=919351504729&text=Book++Gym&type=phone_number&app_absent=0',
    },
  ],

  'meditation': [
    {
      id: 'med-1',
      name: 'RELAXING MEDITATION IN NATURE',
      location: 'Central Park',
      thumb: '/images/meditation.png',
      details: 'Guided meditation',
      rating: 4.9,
      reviewCount: 22,
      images: ['/images/meditation.png'],
      description: 'Guided meditation for deep relaxation.',
      facilities: ['Guided Meditation', 'Mindfulness'],
      hours: '6 AM – 7 AM',
      pricing: '₹60 per session',
      contact: { phone: '+91 8619439126', address: 'Central Park' },
      qrCode: '/images/fitness.png',
      bookingLink: 'https://api.whatsapp.com/send/?phone=919351504729&text=Book++Gym&type=phone_number&app_absent=0',
    },
    {
      id: 'med-2',
      name: 'RELAXING MEDITATION',
      location: 'Gopalpura, Jaipur',
      thumb: '/images/amit-m.png',
      details: 'Guided meditation',
      rating: 4.9,
      reviewCount: 22,
      images: ['/images/amit-m.png'],
      description: 'Guided meditation for deep relaxation.',
      facilities: ['Guided Meditation', 'Mindfulness'],
      hours: '6 AM – 7 AM',
      pricing: '₹80 per session',
      contact: { phone: '+91 8619439126', address: 'Gopalpura, Jaipur' },
      qrCode: '/images/fitness.png',
      bookingLink: 'https://api.whatsapp.com/send/?phone=919351504729&text=Book++Gym&type=phone_number&app_absent=0',
    },
  ],

  'nature-meditation': [
    {
      id: 'nm-1',
      name: 'RELAXING MEDITATION IN NATURE',
      location: 'Central Park',
      thumb: '/images/meditation.png',
      details: 'Nature meditation',
      rating: 4.8,
      reviewCount: 15,
      images: ['/images/meditation.png'],
      description: 'Peaceful meditation session in natural surroundings.',
      facilities: ['Outdoor', 'Guided Session'],
      hours: '6 AM – 7 AM',
      pricing: '₹60 per session',
      contact: { phone: '+91 8619439126', address: 'Central Park' },
      qrCode: '/images/fitness.png',
      bookingLink: 'https://api.whatsapp.com/send/?phone=919351504729&text=Book++Gym&type=phone_number&app_absent=0',
    },
  ],

  'dance_party': [
    {
      id: 'ndp-1',
      name: 'Eco Fitness dance by Shalini maam',
      location: 'Central Park',
      thumb: '/images/dancecp.png',
      details: 'Outdoor dance fitness',
      rating: 4.5,
      reviewCount: 18,
      images: ['/images/dancecp.png'],
      description: 'Fun outdoor fitness dance experience.',
      facilities: ['Dance', 'Outdoor', 'Music'],
      hours: '5 PM – 7 PM',
      pricing: '₹60 per session',
      contact: { phone: '+91 8619439126', address: 'Central Park' },
      qrCode: '/images/fitness.png',
      bookingLink: 'https://api.whatsapp.com/send/?phone=919351504729&text=Book++Gym&type=phone_number&app_absent=0',
    },
  ],
},

'doctors': {
    'all': [
      {
        id: 'd7-med',
        name: 'D7 Med Multispeciality Clinic',
        location: 'Brookefield, Bengaluru',
        thumb: '/images/d7-med.png',
        details: 'D7 Med Multispeciality Clinic',
        rating: 4.8,
        reviewCount: 342,
        images: ['/images/d7-med.png'],
        description: 'D7 Med Multispeciality Clinic.',
        facilities: ['Consultation'],
        hours: '7 PM – 9 PM',
        pricing: '₹900',
        contact: { phone: '+91 8619439126', address: 'Brookefield' },
        mapUrl: '',
        qrCode: '/images/fitness.png',
        bookingLink: 'https://api.whatsapp.com/send/?phone=919351504729&text=Book++Gym&type=phone_number&app_absent=0',
      },
      {
        id: 'd7-Sreenivasa',
        name: 'Dr Sreenivasa Rao K',
        location: 'Brookefield, Bengaluru',
        thumb: '/images/d7-Sreenivasa.png',
        details: 'General Physician',
        rating: 4.8,
        reviewCount: 342,
        images: ['/images/d7-Sreenivasa.png'],
        description: 'MBBS, Diploma in Medical Radio-Diagnosis, 32 years experience overall Radiologist , General Physician',
        facilities: ['Consultation'],
        hours: '7 PM – 9 PM',
        pricing: '₹900',
        contact: { phone: '+91 8619439126', address: 'Brookefield' },
        mapUrl: '',
        qrCode: '/images/fitness.png',
        bookingLink: 'https://api.whatsapp.com/send/?phone=919351504729&text=Book++Gym&type=phone_number&app_absent=0',
      },
      {
        id: 'd7-Khoushik',
        name: 'Dr Khoushik K H',
        location: 'Brookefield, Bengaluru',
        thumb: '/images/d7-Khoushik.png',
        details: 'General Physician',
        rating: 4.8,
        reviewCount: 342,
        images: ['/images/d7-Khoushik.png'],
        description: 'MBBS, MD - General Medicine 8 years experience overall General Physician , Internal Medicine',
        facilities: ['Consultation'],
        hours: '7 PM – 9 PM',
        pricing: '₹900',
        contact: { phone: '+91 8619439126', address: 'Brookefield' },
        mapUrl: '',
        qrCode: '/images/fitness.png',
        bookingLink: 'https://api.whatsapp.com/send/?phone=919351504729&text=Book++Gym&type=phone_number&app_absent=0',
      },
      {
        id: 'dr-plabani-sarkar',
        name: 'Dr. Plabani Sarkar',
        location: 'Brookefield, Bengaluru',
        thumb: '/images/dr-plabani-sarkar.png',
        details: 'OBSTETRICS & GYNAECOLOGIST',
        rating: 4.8,
        reviewCount: 342,
        images: ['/images/dr-plabani-sarkar.png'],
        description: 'Expert in women\'s health and reproductive care',
        facilities: ['Consultation'],
        hours: '7 PM – 9 PM',
        pricing: '₹900',
        contact: { phone: '+91 8619439126', address: 'Brookefield' },
        mapUrl: '',
        qrCode: '/images/fitness.png',
        bookingLink: 'https://api.whatsapp.com/send/?phone=919351504729&text=Book++Gym&type=phone_number&app_absent=0',
      },
      {
        id: 'dr-manjunath-pandit',
        name: 'Dr. Manjunath Pandit',
        location: 'Brookefield, Bengaluru',
        thumb: '/images/dr-manjunath-pandit.png',
        details: 'Interventional Cardiology',
        rating: 4.9,
        reviewCount: 412,
        images: ['/images/dr-manjunath-pandit.png'],
        description: 'Specializing in advanced cardiac care and interventional heart procedures.',
        facilities: ['Consultation'],
        hours: '4 PM – 5 PM',
        pricing: '₹1,100',
        contact: { phone: '+91 8619439126', address: 'Brookefield' },
        mapUrl: '',
        qrCode: '/images/fitness.png',
        bookingLink: 'https://api.whatsapp.com/send/?phone=919351504729&text=Book++Gym&type=phone_number&app_absent=0',
      },
      {
        id: 'sanjiwani-chikitsa-kendra',
        name: 'Sanjiwani Chikitsa Kendra',
        location: 'Kondapur, Hyderabad',
        thumb: '/images/Sanjiwani Chikitsa Kendra.png',
        details: 'Multi Speciality',
        rating: 4.6,
        reviewCount: 245,
        images: ['/images/Sanjiwani Chikitsa Kendra.png'],
        description: 'A premium multi-speciality healthcare center providing comprehensive medical services.',
        facilities: ['Consultation'],
        hours: '9 AM – 8 PM',
        pricing: '₹800',
        contact: { phone: '+91 8619439126', address: "201, 2nd Floor, Kadiri's Apurupa Urban, Botanical Gardens Road, Landmark: Near Chirec School, Hyderabad" },
        mapUrl: '',
        qrCode: '/images/fitness.png',
        bookingLink: 'https://api.whatsapp.com/send/?phone=919351504729&text=Book++Gym&type=phone_number&app_absent=0',
      },
      {
        id: 'dr-rakesh-vuppala',
        name: 'Dr. Rakesh Vuppala',
        location: 'Kondapur, Hyderabad',
        thumb: '/images/rakes-neoent.jpeg',
        details: 'ENT Specialist',
        rating: 4.8,
        reviewCount: 180,
        images: ['/images/rakes-neoent.jpeg'],
        description: 'Experienced ENT specialist offering advanced treatments for ear, nose, and throat conditions.',
        facilities: ['Consultation'],
        hours: '10 AM – 6 PM',
        pricing: '₹750',
        contact: { phone: '+91 8619439126', address: "201, 2nd Floor, Kadiri's Apurupa Urban, Botanical Gardens Road, Landmark: Near Chirec School, Hyderabad" },
        mapUrl: '',
        qrCode: '/images/fitness.png',
        bookingLink: 'https://api.whatsapp.com/send/?phone=919351504729&text=Book++Gym&type=phone_number&app_absent=0',
      },
      {
        id: 'neo-ent',
        name: 'Neo ENT',
        location: 'Kondapur, Hyderabad',
        thumb: '/images/neo ent.png',
        details: 'ENT Clinic',
        rating: 4.7,
        reviewCount: 210,
        images: ['/images/neo ent.png'],
        description: 'State-of-the-art ENT clinic focused on delivering personalized ear, nose, and throat care.',
        facilities: ['Consultation'],
        hours: '10 AM – 8 PM',
        pricing: '₹800',
        contact: { phone: '+91 8619439126', address: "201, 2nd Floor, Kadiri's Apurupa Urban, Botanical Gardens Road, Landmark: Near Chirec School, Hyderabad" },
        mapUrl: '',
        qrCode: '/images/fitness.png',
        bookingLink: 'https://api.whatsapp.com/send/?phone=919351504729&text=Book++Gym&type=phone_number&app_absent=0',
      },
      {
        "id": "dr-athira-haridas",
        "name": "Dr. Athira Haridas",
        "location": "Brookefield, Bengaluru",
        "thumb": "/images/dr-athira-haridas.png",
        "details": "General Medicine",
        "rating": 4.5,
        "reviewCount": 189,
        "images": ["/images/dr-athira-haridas.png"],
        "description": "Providing comprehensive primary care and treatment for chronic conditions.",
        "facilities": ["Consultation"],
        "hours": "6 PM – 9 PM",
        "pricing": "650.00",
        "contact": { "phone": "+91 8619439126", "address": "Brookefield" },
        "mapUrl": "",
        "qrCode": "/images/fitness.png",
        "bookingLink": "https://api.whatsapp.com/send/?phone=919351504729&text=Book++Gym&type=phone_number&app_absent=0"
      },
      {
        "id": "dr-pavan-kumar-ym",
        "name": "Dr. Pavan Kumar Y M",
        "location": "Brookefield, Bengaluru",
        "thumb": "/images/dr-pavan-kumar-ym.png",
        "details": "Gastroenterologist",
        "rating": 4.7,
        "reviewCount": 215,
        "images": ["/images/dr-pavan-kumar-ym.png"],
        "description": "Specialist in digestive health, liver diseases, and gastrointestinal wellness.",
        "facilities": ["Consultation"],
        "hours": "7:30 PM – 9:30 PM",
        "pricing": "900.00",
        "contact": { "phone": "+91 8619439126", "address": "Brookefield" },
        "mapUrl": "",
        "qrCode": "/images/fitness.png",
        "bookingLink": "https://api.whatsapp.com/send/?phone=919351504729&text=Book++Gym&type=phone_number&app_absent=0"
      },
      {
        "id": "dr-santosh-kumar-m",
        "name": "Dr. Santosh Kumar M",
        "location": "Brookefield, Bengaluru",
        "thumb": "/images/dr-santosh-kumar-m.png",
        "details": "Urologist",
        "rating": 4.6,
        "reviewCount": 167,
        "images": ["/images/dr-santosh-kumar-m.png"],
        "description": "Comprehensive urological care focusing on kidney health and urinary disorders.",
        "facilities": ["Consultation"],
        "hours": "6 PM – 8 PM",
        "pricing": "900.00",
        "contact": { "phone": "+91 8619439126", "address": "Brookefield" },
        "mapUrl": ""
      },
      {
        "id": "dr-nithya-shekar",
        "name": "Dr. Nithya Shekar",
        "location": "Brookefield, Bengaluru",
        "thumb": "/images/dr-nithya-shekar.png",
        "details": "General Surgery & Laproscopic Surgeon",
        "rating": 4.8,
        "reviewCount": 298,
        "images": ["/images/dr-nithya-shekar.png"],
        "description": "Expert surgeon specializing in advanced minimally invasive laparoscopic procedures.",
        "facilities": ["Consultation"],
        "hours": "7:30 PM – 9:30 PM",
        "pricing": "700.00",
        "contact": { "phone": "+91 8619439126", "address": "Brookefield" },
        "mapUrl": ""
      },
      {
        "id": "dr-geeta-pavadeppagol",
        "name": "Dr. Geeta Pavadeppagol",
        "location": "Brookefield, Bengaluru",
        "thumb": "/images/dr-geeta-pavadeppagol.png",
        "details": "Paediatrician",
        "rating": 4.9,
        "reviewCount": 450,
        "images": ["/images/dr-geeta-pavadeppagol.png"],
        "description": "Dedicated to child healthcare, growth monitoring, and pediatric wellness.",
        "facilities": ["Consultation"],
        "hours": "6 PM – 9 PM",
        "pricing": "700.00",
        "contact": { "phone": "+91 8619439126", "address": "Brookefield" },
        "mapUrl": ""
      },
      {
        "id": "dr-chaithanya-yalagiri",
        "name": "Dr. Chaithanya Yalagiri",
        "location": "Brookefield, Bengaluru",
        "thumb": "/images/dr-chaithanya-yalagiri.png",
        "details": "General Medicine",
        "rating": 4.4,
        "reviewCount": 122,
        "images": ["/images/dr-chaithanya-yalagiri.png"],
        "description": "Expert consultation for general health, fever, and routine wellness checks.",
        "facilities": ["Consultation"],
        "hours": "10 AM – 7 PM",
        "pricing": "550.00",
        "contact": { "phone": "+91 8619439126", "address": "Brookefield" },
        "mapUrl": ""
      },
      {
        "id": "dr-aprajita-singh",
        "name": "Dr. Aprajita Singh",
        "location": "Brookefield, Bengaluru",
        "thumb": "/images/dr-aprajita-singh.png",
        "details": "General Medicine",
        "rating": 4.5,
        "reviewCount": 204,
        "images": ["/images/dr-aprajita-singh.png"],
        "description": "Comprehensive internal medicine specialist for adult and geriatric care.",
        "facilities": ["Consultation"],
        "hours": "7:30 PM – 9:30 PM",
        "pricing": "550.00",
        "contact": { "phone": "+91 8619439126", "address": "Brookefield" },
        "mapUrl": ""
      },
      {
        "id": "dr-raghu-a",
        "name": "Dr. Raghu A",
        "location": "Kanchanbagh, Hyderabad",
        "thumb": "/images/dr-raghu-a.png",
        "details": "General Physician",
        "rating": 4.7,
        "reviewCount": 310,
        "images": ["/images/dr-raghu-a.png"],
        "description": "Senior physician at Apollo Hospitals providing expert medical management.",
        "facilities": ["Consultation"],
        "hours": "9 AM – 5 PM",
        "pricing": "Consultation on request",
        "contact": { "phone": "+91 8619439126", "address": "Kanchanbagh" },
        "mapUrl": ""
      },
      {
        "id": "dr-sunil",
        "name": "Dr. Sunil",
        "location": "Banjara Hills, Hyderabad",
        "thumb": "/images/dr-sunil.png",
        "details": "General Physician",
        "rating": 4.6,
        "reviewCount": 195,
        "images": ["/images/dr-sunil.png"],
        "description": "Holistic primary care and healthcare management in the Banjara Hills region.",
        "facilities": ["Consultation"],
        "hours": "10 AM – 6 PM",
        "pricing": "Consultation on request",
        "contact": { "phone": "+91 8619439126", "address": "Banjara Hills" },
        "mapUrl": ""
      },
      {
        "id": "dr-sanjay-kanodia",
        "name": "Dr. Sanjay Kanodia",
        "location": "Sethi Colony, Jaipur",
        "thumb": "/images/dr-sanjay-kanodia.png",
        "details": "Skin Category (Dermatology)",
        "rating": 4.9,
        "reviewCount": 475,
        "images": ["/images/dr-sanjay-kanodia.png"],
        "description": "Premier dermatologist in Jaipur offering clinical and aesthetic skin solutions.",
        "facilities": ["Consultation"],
        "hours": "11 AM – 7 PM",
        "pricing": "Consultation on request",
        "contact": { "phone": "+91 8619439126", "address": "Sethi Colony" },
        "mapUrl": ""
      },
      {
        "id": "dr-sudhanshu-gupta",
        "name": "Dr. Sudhanshu Gupta",
        "location": "Raja Park, Jaipur",
        "thumb": "/images/sudhanshu.png",
        "details": "Dentist Category",
        "rating": 4.7,
        "reviewCount": 320,
        "images": ["/images/sudhanshu.png"],
        "description": "Advanced dental care and oral health treatments at Denta Care Clinic.",
        "facilities": ["Consultation"],
        "hours": "10 AM – 8 PM",
        "pricing": "Consultation on request",
        "contact": { "phone": "+91 8619439126", "address": "Raja Park" },
        "mapUrl": ""
      },
      {
        "id": "dr-neeraj-bhutani",
        "name": "Dr. Neeraj Bhutani",
        "location": "Adarsh Nagar, Jaipur",
        "thumb": "/images/dr-neeraj-bhutani.png",
        "details": "General Physician Category",
        "rating": 4.8,
        "reviewCount": 260,
        "images": ["/images/dr-neeraj-bhutani.png"],
        "description": "Experienced family physician providing medical care for all age groups.",
        "facilities": ["Consultation"],
        "hours": "10 AM – 2 PM & 6 PM – 9 PM",
        "pricing": "Consultation on request",
        "contact": { "phone": "+91 8619439126", "address": "Adarsh Nagar" },
        "mapUrl": ""
      },
      {
        "id": "dr-prateek-dental",
        "name": "Dr. Prateek's Dental Center",
        "location": "Raja Park, Jaipur",
        "thumb": "/images/dr-prateeks-dental-center.png",
        "details": "Dentist Category (Implant Specialist)",
        "rating": 4.9,
        "reviewCount": 410,
        "images": ["/images/dr-prateeks-dental-center.png"],
        "description": "State-of-the-art dental and implant center focusing on modern oral surgery.",
        "facilities": ["Consultation"],
        "hours": "10 AM – 7 PM",
        "pricing": "Consultation on request",
        "contact": { "phone": "+91 8619439126", "address": "Raja Park" },
        "mapUrl": ""
      }
    ]
},

  'events': {
    "all": [
    {
      "id": "event-1",
      "name": "The Baddy Club Week 14 (Sunday)",
      "location": "Bengaluru",
      "thumb": "/images/baddy club.png",
      "details": "Sunday Badminton Session",
      "rating": 4.8,
      "reviewCount": 156,
      "images": ["/images/baddy club.png"],
      "description": "This Sunday, we’re back in court. Join us for a solid badminton session with good games and even better energy. Spots are limited.",
      "facilities": ["Badminton Court", "Refreshments", "Good Energy"],
      "hours": "11:45 AM – 2:45 PM",
      "pricing": "₹199",
      "contact": {
        "phone": "+91 8619439126",
        "address": "GameFit Sports Academy, Bengaluru"
      }
    },
    {
      "id": "event-2",
      "name": "Mayan Weekender",
      "location": "Goa",
      "thumb": "/images/mayan weekender.png",
      "details": "Beach Club Music Festival",
      "rating": 4.7,
      "reviewCount": 420,
      "images": ["/images/mayan weekender.png"],
      "description": "Mayan Beach Club Presents: Mayan Weekender Featuring a powerful lineup of artists including Belkond, Locate, and Blithe across three days.",
      "facilities": ["Live Music", "Beachfront", "Bar & Kitchen"],
      "hours": "3:00 PM – 10:00 PM",
      "pricing": "₹199",
      "contact": {
        "phone": "+91 8619439126",
        "address": "Mayan Beach Club, Goa"
      }
    },
    {
      "id": "event-3",
      "name": "After Hours - Weekend Party",
      "location": "Kasol",
      "thumb": "/images/after hours.png",
      "details": "Underground Mountain Party",
      "rating": 4.9,
      "reviewCount": 285,
      "images": ["/images/after hours.png"],
      "description": "3 Nights of Underground Mayhem! Explosive nights with mind-altering visuals and relentless beats in the heart of Parvati Valley.",
      "facilities": ["Underground Beats", "Mountain Vibe", "Visual Arts"],
      "hours": "8:00 PM – 5:00 AM",
      "pricing": "₹199",
      "contact": {
        "phone": "+91 8619439126",
        "address": "Pirates of Parvati, Kasol"
      }
    },
    {
      "id": "event-4",
      "name": "Radiant Night at H.O.D ft DJ James",
      "location": "Bengaluru",
      "thumb": "/images/radiant night.png",
      "details": "Premium Club Night",
      "rating": 4.6,
      "reviewCount": 198,
      "images": ["/images/radiant night.png"],
      "description": "Turn your Sunday into something extraordinary. An evening where music, lights, and energy come together with DJ James.",
      "facilities": ["Dance Floor", "DJ Performance", "Cocktails"],
      "hours": "8:00 PM – 1:00 AM",
      "pricing": "₹199",
      "contact": {
        "phone": "+91 8619439126",
        "address": "House of Dopamine, Koramangala, Bengaluru"
      }
    },
    {
      "id": "event-5",
      "name": "Bollytech ft. DJ Aditya",
      "location": "Mumbai",
      "thumb": "/images/bollytech.png",
      "details": "Bollywood & Tech Fusion",
      "rating": 4.5,
      "reviewCount": 310,
      "images": ["/images/bollytech.png"],
      "description": "Get ready for a fusion of Bollywood & Tech beats. Groove all night with electrifying music and desi vibes at R-ADDA.",
      "facilities": ["Fusion Music", "Valet Parking", "VIP Lounge"],
      "hours": "8:00 PM – 1:30 AM",
      "pricing": "₹199",
      "contact": {
        "phone": "+91 9920039651",
        "address": "R-ADDA, Juhu, Mumbai"
      }
    },
    {
      "id": "event-6",
      "name": "Euphoria Sunday",
      "location": "Pune",
      "thumb": "/images/euphoria sunday.png",
      "details": "Sundowner Experience",
      "rating": 4.4,
      "reviewCount": 142,
      "images": ["/images/euphoria sunday.png"],
      "description": "Experience pure euphoria this Sunday with a curated vibe that elevates your weekend finish. High-energy beats and great company.",
      "facilities": ["Open Air", "Sundowner Vibes", "Lounge"],
      "hours": "8:00 PM – 1:30 AM",
      "pricing": "₹199",
      "contact": {
        "phone": "+91 8619439126",
        "address": "Di Mora, Pune"
      }
    },
    {
      "id": "event-7",
      "name": "Afrobeat Sunday | Anniversary",
      "location": "Mumbai",
      "thumb": "/images/afrobeat.png",
      "details": "4 Year Anniversary Edition",
      "rating": 4.9,
      "reviewCount": 470,
      "images": ["/images/afrobeat.png"],
      "description": "Join us for a massive celebration of Afrobeats Sunday. A special 4-year anniversary edition featuring the best rhythmic beats.",
      "facilities": ["Celebration", "Signature Cocktails", "Themed Decor"],
      "hours": "9:00 PM – 1:00 AM",
      "pricing": "₹199",
      "contact": {
        "phone": "+91 8619439126",
        "address": "Raasta Bombay Khar, Mumbai"
      }
    }
  ],
   "run-clubs": [
    {
      "id": "run-3",
      "name": "Run Addicts",
      "location": "Bangalore",
      "thumb": "/images/RunAddicts.png",
      "details": "Morning Community Run",
      "rating": 4.7,
      "reviewCount": 245,
      "images": ["/images/RunAddicts.png"],
      "description": "A vibrant community run at Cubbon Park to kickstart your day with like-minded fitness enthusiasts.",
      "facilities": ["Pacer Groups", "Hydration Support", "Community"],
      "hours": "6 AM – 9 AM (26 Apr)",
      "pricing": "₹199",
      "contact": { "phone": "+91 8619439126", "address": "Cubbon Park, Bangalore" }
    },
    {
      "id": "run-4",
      "name": "The Run Scene",
      "location": "Bangalore",
      "thumb": "/images/therunscene.png",
      "details": "Whitefield Morning Sprint",
      "rating": 4.5,
      "reviewCount": 182,
      "images": ["/images/therunscene.png"],
      "description": "Connect with local runners for a structured and energetic morning session in the heart of Whitefield.",
      "facilities": ["Pacer Groups", "Hydration Support", "Community"],
      "hours": "6:45 AM onwards",
      "pricing": "₹199",
      "contact": { "phone": "+91 8619439126", "address": "KPTO Entrance, Whitefield, Bangalore" }
    },
    {
      "id": "run-5",
      "name": "JP Nagar Run Club",
      "location": "Bangalore",
      "thumb": "/images/JP.png",
      "details": "Decathlon Flagship Run",
      "rating": 4.9,
      "reviewCount": 310,
      "images": ["/images/JP.png"],
      "description": "High-energy group run starting from the Bannerghatta flagship store, perfect for consistent training.",
      "facilities": ["Pacer Groups", "Hydration Support", "Community"],
      "hours": "7:00 AM onwards",
      "pricing": "₹199",
      "contact": { "phone": "+91 8619439126", "address": "Decathlon Bannerghatta Flagship Store, Bangalore" }
    },
    {
      "id": "run-1",
      "name": "Jaipur Road Runners",
      "location": "Central Park",
      "thumb": "/images/run-0.png",
      "details": "Community Run",
      "rating": 4.8,
      "reviewCount": 320,
      "images": ["/images/run-0.png"],
      "description": "Join the city’s largest community of runners for daily morning laps.",
      "facilities": ["Pacer Groups", "Hydration Support"],
      "hours": "5:30 AM – 7:30 AM",
      "pricing": "Free / Community based",
      "contact": { "phone": "+91 8619439126", "address": "Central Park Gate 2" }
    },
    {
      "id": "run-2",
      "name": "Pink City Half-Marathon Club",
      "location": "Central park",
      "thumb": "/images/run-2.png",
      "details": "Endurance Training",
      "rating": 4.5,
      "reviewCount": 95,
      "images": ["/images/run-2.png"],
      "description": "Dedicated training for long-distance running and marathon prep.",
      "facilities": ["Coaching", "Stretching Sessions"],
      "hours": "6:00 AM – 8:30 AM",
      "pricing": "₹500 monthly",
      "contact": { "phone": "+91 8619439126", "address": "Central park" }
    }
  ],

    'nature-dance': [
      {
        id: 'nd-1',
        name: 'Sunrise Groove in Park',
        location: 'Turbo turf',
        thumb: '/images/nd-1.jpg',
        details: 'Eco-Dance Session',
        rating: 4.9,
        reviewCount: 55,
        images: ['/images/nd-1.png'],
        description: 'Expressive movement and dance in the heart of nature.',
        facilities: ['Wireless Headphones', 'Nature Setting'],
        hours: '7:00 AM – 8:30 AM',
        pricing: '₹150 per session',
        contact: { phone: '+91 8619439126', address: 'Turbo turf' },
      },
      // {
      //   id: 'nd-2',
      //   name: 'Forest Flow Contemporary',
      //   location: 'Kanak Vrindavan',
      //   thumb: '/images/dance2.png',
      //   details: 'Contemporary Dance',
      //   rating: 4.7,
      //   reviewCount: 38,
      //   images: ['/images/dance2.png'],
      //   description: 'A blend of yoga and contemporary dance performed outdoors.',
      //   facilities: ['Instructor', 'Changing Rooms'],
      //   hours: '4:30 PM – 6:00 PM',
      //   pricing: '₹200 per session',
      //   contact: { phone: '+91 8619439126', address: 'Amer Road' },
      // },
      // {
      //   id: 'nd-3',
      //   name: 'Open Air Bollywood Blast',
      //   location: 'Central Park',
      //   thumb: '/images/dance3.png',
      //   details: 'Fitness Dance',
      //   rating: 4.6,
      //   reviewCount: 210,
      //   images: ['/images/dance3.png'],
      //   description: 'High-energy Bollywood dance steps to get your heart racing in the fresh air.',
      //   facilities: ['Sound System', 'Water'],
      //   hours: '6:30 AM – 7:30 AM',
      //   pricing: '₹100 per session',
      //   contact: { phone: '+91 8619439126', address: 'Central Park' },
      // },
      // {
      //   id: 'nd-4',
      //   name: 'Sunset Soul Movement',
      //   location: 'Nahargarh biological park',
      //   thumb: '/images/dance4.png',
      //   details: 'Mindful Dance',
      //   rating: 4.8,
      //   reviewCount: 22,
      //   images: ['/images/dance4.png'],
      //   description: 'A meditative dance experience as the sun goes down.',
      //   facilities: ['Quiet Zone', 'Instructors'],
      //   hours: '5:30 PM – 7:00 PM',
      //   pricing: '₹300 per session',
      //   contact: { phone: '+91 8619439126', address: 'Delhi Highway' },
      // }
    ],

    'fun-group-workouts': [
      {
        id: 'grp-1',
        name: 'Kabbadi & Games Bootcamp',
        location: 'Bhagat Singh Park',
        thumb: '/images/fg-1.png',
        details: 'Social Fitness',
        rating: 4.9,
        reviewCount: 80,
        images: ['/images/fg-1.png'],
        description: 'Ditch the gym for old-school childhood games that burn calories.',
        facilities: ['Equipment', 'Refreshments'],
        hours: '6:30 AM – 8:00 AM',
        pricing: '₹50 per session',
        contact: { phone: '+91 8619439126', address: 'Raja Park' },
      },
      {
        id: 'grp-2',
        name: 'The Fitness Carnival',
        location: 'Tilak park',
        thumb: '/images/fg-2.png',
        details: 'Weekly Meetup',
        rating: 4.7,
        reviewCount: 140,
        images: ['/images/fg-2.png'],
        description: 'Relay races, team challenges, and circuit training in a fun carnival style.',
        facilities: ['Sound System', 'Medals/Rewards'],
        hours: '7:00 AM – 9:00 AM (Sundays)',
        pricing: '₹100 per session',
        contact: { phone: '+91 8619439126', address: 'Tilak park' },
      },
     
    ],
        'trekking': [
      {
        id: 'trek-1',
        name: 'Nahargarh Sunrise Trek',
        location: 'Nahargarh Fort Trail',
        thumb: '/images/trek1.png',
        details: 'Guided Nature Hike',
        rating: 4.9,
        reviewCount: 150,
        images: ['/images/trek1.png'],
        description: 'A scenic sunrise trek through the Aravalli hills leading to Nahargarh Fort.',
        facilities: ['Guided Tour', 'First Aid', 'Water Stations'],
        hours: '5:00 AM – 8:00 AM',
        pricing: '₹200 per person',
        contact: { phone: '+91 8619439126', address: 'Nahargarh Foot Hills' },
      },
      {
        id: 'trek-2',
        name: 'Chour Ghati Exploration',
        location: 'Galta Ji Hills',
        thumb: '/images/trek2.png',
        details: 'Intermediate Trek',
        rating: 4.7,
        reviewCount: 88,
        images: ['/images/trek2.png'],
        description: 'Explore the hidden valley of Chour Ghati with experienced trekkers.',
        facilities: ['Expert Guide', 'Photography'],
        hours: '6:00 AM – 10:00 AM',
        pricing: '₹350 per person',
        contact: { phone: '+91 8619439126', address: 'Galta Ji Gate' },
      },
      {
        id: 'trek-3',
        name: 'Hathni Kund Nature Trail',
        location: 'Amer Forest',
        thumb: '/images/trek3.png',
        details: 'Eco-friendly Trek',
        rating: 4.8,
        reviewCount: 112,
        images: ['/images/trek3.png'],
        description: 'A lush green trail during monsoons leading to a beautiful ancient temple.',
        facilities: ['Bird Watching', 'Guided Hike'],
        hours: '6:00 AM – 9:30 AM',
        pricing: '₹150 per person',
        contact: { phone: '+91 8619439126', address: 'Amer Road' },
      },
      {
        id: 'trek-4',
        name: 'Jhalana Leopard Safari Trek',
        location: 'Jhalana Forest',
        thumb: '/images/trek4.png',
        details: 'Wildlife Walk',
        rating: 4.6,
        reviewCount: 75,
        images: ['/images/trek4.png'],
        description: 'A controlled walking trek near the wildlife reserve area.',
        facilities: ['Safety Gear', 'Forest Guide'],
        hours: '5:30 AM – 8:30 AM',
        pricing: '₹500 per person',
        contact: { phone: '+91 8619439126', address: 'Malviya Nagar' },
      }
    ]
  }
};

export type SubcategoryMeta = {
  id: string;
  name: string;
  description: string;
  image: string;
};

export const subcategoriesMap: Record<string, SubcategoryMeta[]> = {
  'sports-venues': [
    { id: 'cricket-pitch', name: 'Cricket Pitch', description: 'Nets and turf wickets', image: '/images/c5.png' },
    { id: 'football-turf', name: 'Football Turf', description: '5-a-side / 7-a-side', image: '/images/f3.png' },
    { id: 'pickleball', name: 'Pickleball', description: 'Courts and coaching', image: '/images/p3.png' },
  ],
  'fitness-venues': [
    { id: 'gym', name: 'Gym', description: 'Strength & cardio workouts', image: '/images/CrossFit Gym.png' },
    { id: 'zumba', name: 'Zumba', description: 'Dance-based cardio fitness', image: '/images/zumba.jpg' },
    { id: 'yoga', name: 'Yoga', description: 'Flexibility & mindfulness', image: '/images/parkyoga.png' },
    { id: 'nature_workout', name: 'Nature Workout', description: 'Outdoor fitness sessions', image: '/images/nature workout.png' },
    { id: 'meditation', name: 'Meditation', description: 'Relaxation & focus', image: '/images/meditation.png' },
    { id: 'dance_party', name: 'Fitness Dance Party', description: 'Outdoor dance fitness', image: '/images/dancecp.png' },
  ],

  // Update your subcategoriesMap
  'events': [
    { id: 'all', name: 'Party| Music| Club', description: 'Music, DJ, Club parties', image: '/images/radiant night.png' },
    { id: 'run-clubs', name: 'Run Clubs', description: 'Morning & evening run groups', image: '/images/run-0.png' },
    { id: 'nature-dance', name: 'Nature Dance', description: 'Dance & groove in the wild', image: '/images/nd-1.jpg' },
    { id: 'fun-group-workouts', name: 'Fun Group Workouts', description: 'Social fitness & games', image: '/images/fg-1.png' },
     { id: 'trekking', name: 'Trekking', description: 'Nature trails & hill climbs', image: '/images/trek-1.png' }
  ]
};

export const readableNames: Record<string, string> = {
  'sports-venues': 'Sports Venues',
  'fitness-venues': 'Fitness venues',
  'doctors': 'Doctors',
  // Update your readableNames
  'events': 'Events & Meetups' // Added this
};
